import { createPartialRoute } from "./PartialRouteDefinition";
import type { RouteParametersOf } from "./RouteTemplate";
import { routeParam, routeTemplate } from "./RouteTemplate";
export type SpaceRouteParameters = RouteParametersOf<(typeof spacePartialRoute)["template"]>;
export const spacePartialRoute = createPartialRoute(routeTemplate `/${routeParam("spaceId")}`);
